export default function Logo (props) {
    return (
        <div 
        style={props.flex && {
            alignItems: "center",
            justifyContent: "center"
        }}
        className={`logo ${props.flex ? "flex" : ""}`}>
            <h1>
                {props.mode === "dark" ?
                    <img width={props.width} src={require("../../docs/logo/light.png")} alt="logo"/> 
                    :
                    <img width={props.width} src={require("../../docs/logo/dark.png")} alt="logo"/> 
                }
            </h1>
            <h2 style={{
                fontSize: props.width
            }} className={props.mode === "dark" ? "light" : "dark"}>Zone</h2>
        </div>
    )
}